export const ERROR_LOG_TYPES = {
  INFO: 'info',
  ERROR: 'error',
};

const Sentry = require('@sentry/browser');

export const logSentryError = (error, level = ERROR_LOG_TYPES.ERROR, ...args) => {
  if (window.Sentry) {
    Sentry.withScope((scope) => {
      if (args.length > 0) {
        if (args.every(({ tag, value }) => tag && value)) {
          args.forEach(({ tag, value }) => {
            scope.setExtra(tag, value);
          });
        } else {
          scope.setExtra('additionalData', args);
        }
      }
      scope.setLevel(level);

      Sentry.captureException(error);
    });
  } else {
    window.queuedSentryErrors = [...(window.queuedSentryErrors || []), { error, level, args }];
  }
};

// load specific version of sentry onto the window.
// alternative to bundling sentry as part of application code.
export const loadSentryLibrary = ({ version } = {}) =>
  new Promise((resolve, reject) => {
    try {
      // Load Sentry onto the page if it has not yet been.
      if (!window.Sentry) {
        const script = document.createElement('script');

        const src = `https://browser.sentry-cdn.com/${version}/bundle.min.js`;
        script.src = src;
        script.type = 'text/javascript';
        script.crossOrigin = 'anonymous';
        script.async = true;
        document.body.appendChild(script);
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`error loading ${src}`));
      } else if (!version) {
        reject(new Error('No version provided'));
      } else {
        resolve();
      }
    } catch (e) {
      reject(e);
    }
  });

// Load and then intitialize Sentry with configuration options.
// Call an error handler function if loading or initialization throws an error.
export const initializeSentry = async ({
  dsn,
  environment,
  user,
  locale,
  release,
  backendEnv,
  version = '5.15.5',
  rn,
}) => {
  await loadSentryLibrary({ version });
  Sentry.init({
    dsn,
    environment,
    release,
    maxBreadcrumbs: 50,
    integrations: [new Sentry.Integrations.Breadcrumbs({ console: false })],
  });
  Sentry.configureScope((scope) => {
    if (locale) {
      scope.setTag('locale', locale);
    }
    if (user) {
      scope.setUser(user);
    }
    if (backendEnv) {
      scope.setTag('backendEnv', backendEnv);
    }
    if (rn) {
      scope.setTag('rn', rn);
    }
  });
  if (window.queuedSentryErrors) {
    window.queuedSentryErrors.forEach(({ error, level, args }) =>
      logSentryError(error, level, ...args)
    );
  }
};
